//test
export const increment = ({commit}) => {
    commit('INCREMENT')
}
export const decrement = ({commit}) => {
    commit('DECREMENT')
}

export const settoken = ({commit}) => {
    commit('SETTOKEN')
}

export const setCurrentIndex= ({commit}) => {
    commit('SETCURRENTINDEX')
}

export const setCategoryArr= ({commit}) => {
    commit('SETCATEGORYARR')
}

export const setProductArr= ({commit}) => {
    commit('SETPRODUCTARR')
}

export const setTopicArr= ({commit}) => {
    commit('SETTOPICARR')
}

export const setLocalBanner = ({commit}) => {
    commit('SETLOCALBANNER')
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js